/** Phase 8 — auth page styling tokens. */

import { button } from '../ui/uiTheme';

export const authPageBg = 'flex min-h-screen items-center justify-center bg-dark-base';

export const authCard =
  'w-full max-w-md rounded-2xl border border-dark-border bg-dark-surface p-8 shadow-2xl shadow-black/60';

export const authBrandClass =
  'bg-gradient-to-r from-brand-purple-light to-brand-teal-light bg-clip-text text-center text-2xl font-bold text-transparent';

export const authTitleClass = 'mt-4 text-center text-2xl font-bold text-slate-100';

export const authSubtitleClass = 'mb-6 mt-1 text-center text-sm text-slate-400';

export const authLabelClass = 'mb-1.5 block text-sm font-medium text-slate-300';

export const authDividerRow = 'my-4 flex items-center gap-3';

export const authDividerLine = 'flex-1 border-t border-dark-border';

export const authDividerText = 'text-xs text-slate-500';

export const authOAuthButton =
  'flex w-full items-center justify-center gap-2 rounded-lg border border-dark-border bg-dark-elevated px-4 py-2.5 text-sm font-medium text-slate-200 transition-all hover:border-dark-border-glow hover:bg-dark-base focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/50';

export const authFooterClass = 'mt-4 text-center text-xs text-slate-500';

export const authFooterLink = 'text-brand-purple-light hover:underline';

export const authPrimaryButton = `${button.primary} flex w-full items-center justify-center gap-2 py-3 disabled:cursor-not-allowed disabled:opacity-40`;

export const authSecondaryButton = button.secondary;

export const authPasswordToggle =
  'absolute right-2.5 top-1/2 -translate-y-1/2 rounded-lg p-1.5 text-slate-500 transition-colors hover:bg-dark-elevated hover:text-slate-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple/50';

export const errorPageBg =
  'flex min-h-[60vh] flex-col items-center justify-center bg-dark-base px-6 py-12 text-center';

export const errorCodeClass =
  'bg-gradient-to-r from-brand-purple-light to-brand-teal-light bg-clip-text text-8xl font-bold text-transparent';

export const errorMessageClass = 'mt-4 text-xl font-medium text-slate-300';

export const errorSubMessageClass = 'mt-2 text-sm text-slate-500';
